import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export interface IMenuItem {
    id?: string;
    title?: string;
    description?: string;
    type: string;       // Possible values: link/dropDown/extLink
    name?: string;      // Used as display text for item and title for separator type
    state?: string;     // Router state
    icon?: string;      // Material icon name
    tooltip?: string;   // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
    active?: boolean;
    roles?: string[];   // Roles that can see this menu item
}

export interface IChildItem {
    id?: string;
    parentId?: string;
    type?: string;
    name: string;       // Display text
    state?: string;     // Router state
    icon?: string;
    sub?: IChildItem[];
    active?: boolean;
}

interface IBadge {
    color: string;      // primary/accent/warn/hex color codes(#fff000)
    value: string;      // Display text
}

interface ISidebarState {
    sidenavOpen?: boolean;
    childnavOpen?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    public sidebarState: ISidebarState = {
        sidenavOpen: true,
        childnavOpen: false
    };
    selectedItem: IMenuItem;

    constructor() {
    }

    defaultMenu: IMenuItem[] = [
        {
            icon: 'i-Bar-Chart',
            name: 'Paneli',
            state: '/warehouse/dashboard',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-Align-Right',
            name: 'Produktet',
            state: '/warehouse/products',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-Checkout-Basket',
            name: 'Stoku Aktual',
            state: '/warehouse/current-stock',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-Arrow-Up-in-Circle',
            name: 'Inventar Hyrje',
            state: '/warehouse/inventory-in',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-Arrow-Down-in-Circle',
            name: 'Inventar Dalje',
            state: '/warehouse/inventory-out',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_USER']
        },
        {
            icon: 'i-Bar-Code',
            name: 'Grupet / Barkodet',
            state: '/warehouse/batches',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-Bell',
            name: 'Njoftimet',
            state: '/warehouse/notifications',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-File-Horizontal-Text',
            name: 'Transaksionet',
            state: '/warehouse/transactions',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
        {
            icon: 'i-File-Clipboard-File--Text',
            name: 'Raportet',
            state: '/warehouse/reports',
            type: 'link',
            roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']
        },
    ];

    // sets iconMenu as default;
    menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
    // navigation component has subscribed to this Observable
    menuItems$ = this.menuItems.asObservable();

    // Call this method after login to filter menu based on user role
  publishNavigationChange(userRole: string) {    
    const filteredMenu = this.defaultMenu.filter(item => {
        if (!item.roles || item.roles.length === 0) {
            return true;
        }
        const hasAccess = item.roles.includes(userRole);
        return hasAccess;
    });
    
    console.log('Filtered menu:', filteredMenu);
    this.menuItems.next(filteredMenu);
}

    // Reset menu to default (useful for logout)
    resetMenu() {
        this.menuItems.next(this.defaultMenu);
    }
}